<template>
  <div>
    <h3 class="title title--6 half-spacing">
      Shipping Method
    </h3>

    <div
      v-if="shipping.methodsAreLoading && !shipping.selectedMethodId"
      class="loader"
    />

    <div
      v-else-if="shipping.methods.length > 0"
      class="card-list card-list--clickable"
    >
      <label
        v-for="method in shipping.methods"
        :key="method.identifier"
        class="card-list__item"
        :for="`shippingMethod${method.identifier}`"
      >
        <div class="card-list__item-section card-list__item-section--stack grow">
          <p class="title title--6 dark">
            {{ method.shippingMethodName }}
          </p>

          <p class="smaller">{{ method.shippingMethodDescription }}</p>
        </div>

        <div class="card-list__item-section no-shrink">
          <p>
            {{ $dollars(method.fee) }}
          </p>
        </div>

        <div class="card-list__item-section no-shrink">
          <div class="checkbox-input checkbox-input--radio checkbox-input--default checkbox-input--no-label-text">
            <div class="checkbox-input__option">
              <input
                :id="`shippingMethod${method.identifier}`"
                class="checkbox-input__input"
                type="radio"
                name="shippingMethod"
                :value="method.identifier"
                :checked="method.identifier === shipping.selectedMethodId"
                @input="changeMethodHandler(method)"
              >

              <div class="checkbox-input__label" />
            </div>
          </div>
        </div>
      </label>
    </div>

    <p
      v-else
      class="danger"
    >
      No shipping methods are currently available for your order.
    </p>
  </div>
</template>



<script>
  import { mapGetters } from 'vuex';



  export default {
    name: 'ShippingMethodSelector',

    computed: {
      ...mapGetters('orders', ['order']),
      ...mapGetters('shipping', ['shipping'])
    },

    watch: {
      'order.subtotal': {
        handler: 'loadMethods',
        immediate: true
      }
    },

    methods: {
      changeMethodHandler(method) {
        this.$store.dispatch('shipping/selectMethod', method.identifier);
      },

      loadMethods() {
        this.$store.dispatch('shipping/getMethods');
      }
    }
  };
</script>
